module.exports = __webpack_public_path__ + "static/media/site-web.df9e9e2e.png";